export default "__VITE_ASSET__Jv_hshD1__"